import { render } from "./PublicLayout.vue?vue&type=template&id=fe2f7c9e&ts=true&lang=pug"
import script from "./PublicLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublicLayout.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__